import React from 'react';
import PropTypes from 'prop-types';
import { Col, Label, Input } from 'reactstrap';
import { IconeCarregar } from '../../../components/Icones';

function InputText({ xs, sm, md, lg, xl, className = "", title, noTitle, placeholder, name, value, onEnter, onChange, onBlur, disabled, required, loading, error, inputRef, styles = {} }) {

    const handlePress = event => {
        if(event.key === 'Enter' && onEnter) onEnter(event);
    }

    const handleChange = event => onChange && onChange(event);

    const handleBlur = event => onBlur && onBlur(event);

    const { input: inputStyle = {}} = styles;

    return (
        <Col 
            xs={xs || 'auto'}
            sm={sm || 'auto'}
            md={md || 'auto'}
            lg={lg || 'auto'}
            xl={xl || 'auto'}
            className={`${className.includes('mb') ? '' : error ? 'mb-1' : 'mb-4'} w-100 ${className ? className : ''}`}
        >
            <div className='w-100'>
                {title ? (
                    <Label>
                        {title}{required ? <span className="label-danger">{' *'}</span> : ""}
                        {loading && <IconeCarregar className="label-carregar" tamanho="lg" />} 
                    </Label>
                ) : noTitle ? "" : <Label className="hide-item">empty</Label>}
                <Input
                    style={inputStyle}
                    innerRef={inputRef}
                    name={name}
                    value={value}
                    placeholder={placeholder ? placeholder : ''}
                    type='text'
                    onKeyPress={handlePress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={disabled}
                />
                {error ? <Label className="label-danger">{error}</Label> : <Label className="hide-item">empty</Label>}
            </div>
        </Col>
    )
}

InputText.propTypes = {
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
    className: PropTypes.string,
    title: PropTypes.string,
    noTitle: PropTypes.bool,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    onEnter: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    loading: PropTypes.bool,
    error: PropTypes.string,
}

export default InputText


// WEBPACK FOOTER //
// ./src/modules/comum/tables/components/inputs/InputText.js